// extracted by mini-css-extract-plugin
export default {"loading":"houseLetter_loading__3HuPQ","pcWrap":"houseLetter_pcWrap__EzARl"};